// Users Form
export const USERS_FORM = 'USERS_FORM'
export const FIRST_NAME = 'firstName'
export const FIRST_NAME_LABEL = 'First Name'
export const LAST_NAME = 'lastName'
export const LAST_NAME_LABEL = 'Last Name'
export const EMAIL = 'email'
export const EMAIL_LABEL = 'Email'
export const ROLES = 'roleId'
export const ROLES_LABEL = 'Roles'
export const JOBS = 'jobId'
export const JOBS_LABEL = 'Jobs'
export const ORGANIZATIONS = 'organizationId'
export const ORGANIZATIONS_LABEL = 'Organizations'
export const SEGMENT = 'segments'
export const SEGMENT_LABEL = 'Segments'
export const NETWORKS = 'networks'
export const NETWORKS_LABEL = 'Networks'

// Profile Form
export const PROFILE_FORM = 'PROFILE_FORM'
export const AVATAR = 'avatar'
export const AVATAR_LABEL = 'Avatar'
export const PHONE = 'phone'
export const PHONE_LABEL = 'Phone'

// Regenerate Password
export const REGENERATE_PASSWORD_FORM = 'REGENERATE_PASSWORD_FORM'
export const OLD_PASSWORD = 'oldPassword'
export const OLD_PASSWORD_LABEL = 'Ancien mot de passe'
export const PASSWORD = 'password'
export const PASSWORD_LABEL = 'Mot de passe'
export const PASSWORD_VERIFICATION = 'verification'
export const PASSWORD_VERIFICATION_LABEL = 'Confirmez le mot de passe'

// Organizations Form
export const ORGANIZATIONS_FORM = 'ORGANIZATIONS_FORM'
export const ORGANIZATION_NAME = 'name'
export const ORGANIZATION_NAME_LABEL = 'Name'

// errors
export const ERROR_REQUIRED = 'Ce champ est requis'

export const ROLE_VALUES = [
  { label: 'Normal', value: 0 },
  { label: 'Network', value: 25 },
  { label: 'Organisation admin', value: 50 },
  { label: 'Admin', value: 100 },
]
